// ─── Company ─────────────────────────────────────────────────────────────────
export const mockCompany = {
  id: 'cmp-001',
  name: 'InvenPro Solutions Pvt. Ltd.',
  address: '204, Tech Park, Baner Road, Pune, Maharashtra 411045',
  gstin: '27AABCU9603R1ZX',
  pan: 'AABCU9603R',
  stateCode: '27',
  stateName: 'Maharashtra',
  phone: '+91 98765 43210',
  email: 'accounts@invenpro.com',
  website: 'www.invenpro.com',
  logoUrl: '',
  financialYearStart: '2024-04-01',
  invoicePrefix: 'INV',
  purchasePrefix: 'PO',
};
export interface MockMaterialReservation {
  id: string;
  productionOrderId: string;
  itemId: string;
  itemName: string;
  itemCode: string;
  requiredQty: number;
  reservedQty: number;
  unit: string;
  status: 'PENDING' | 'RESERVED' | 'PARTIAL' | 'RELEASED';
  warehouseId: string;
}


export interface MockProductionOrder {
  id: string;
  poNumber: string;
  type: 'MTO' | 'MTS';
  status:
  | 'DRAFT'
  | 'PLANNED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'ON_HOLD'
  | 'CANCELLED';
  priority: 'LOW' | 'NORMAL' | 'HIGH' | 'URGENT';
  productId: string;
  productName: string;
  productCode: string;
  isVariant: boolean;
  variantName: string | null;
  bomId: string;
  bomVersion: string;
  plannedQty: number;
  completedQty: number;
  rejectedQty: number;
  unit: string;
  plannedStartDate: string;
  plannedEndDate: string;
  actualStartDate: string | null;
  actualEndDate: string | null;
  salesOrderRef: string | null;
  salesOrderId: string | null;
  warehouseId: string;
  warehouseName: string;
  routingId: string | null;
  routing_id?: string | null;
  workOrders?: Array<{
    id: string;
    woNumber?: string;
    wo_number?: string;
    stageNumber?: number;
    stage_number?: number;
    stageName?: string;
    stage_name?: string;
    status: string;
  }>;
  work_orders?: Array<{
    id: string;
    woNumber?: string;
    wo_number?: string;
    stageNumber?: number;
    stage_number?: number;
    stageName?: string;
    stage_name?: string;
    status: string;
  }>;
  qty_to_produce?: number;
  completed_qty?: number;
  notes: string | null;
  createdBy: string;
  createdAt: string;
}
export interface MockProductionEntry {
  id: string;
  entryNumber: string;
  productionOrderId: string;
  productionOrderNumber: string;
  workOrderId: string;
  workOrderNumber: string;
  stageName: string;
  workCenterId: string;
  workCenterName: string;
  machineId: string | null;
  machineName: string | null;
  operatorId: string;
  operatorName: string;
  shiftId: string;
  shiftName: string;
  date: string;
  producedQty: number;
  rejectedQty: number;
  unit: string;
  startTime: string;
  endTime: string;
  actualTimeMinutes: number;
  notes: string | null;
  enteredBy: string;
  supervisorId: string | null;
  supervisorName: string | null;
  isApproved: boolean;
  createdAt: string;
}

export const mockProductionEntries: MockProductionEntry[] = [
  {
    id: 'pe-001',
    entryNumber: 'PE-2024-001',
    productionOrderId: 'prod-001',
    productionOrderNumber: 'PRD-2024-001',
    workOrderId: 'wo-002',
    workOrderNumber: 'WO-2024-001-2',
    stageName: 'Casting & Cutting',
    workCenterId: 'wc-001',
    workCenterName: 'Cutting Area',
    machineId: 'mc-001',
    machineName: 'CNC Machine 1',
    operatorId: 'op-001',
    operatorName: 'Ramesh Yadav',
    shiftId: 'sh-001',
    shiftName: 'Morning',
    date: '2024-04-16',
    producedQty: 3,
    rejectedQty: 0,
    unit: 'Pcs',
    startTime: '06:00',
    endTime: '10:00',
    actualTimeMinutes: 240,
    notes: null,
    enteredBy: 'op-001',
    supervisorId: null,
    supervisorName: 'Meena Devi',
    isApproved: true,
    createdAt: '2024-04-16T10:30:00Z',
  },
  {
    id: 'pe-002',
    entryNumber: 'PE-2024-002',
    productionOrderId: 'prod-001',
    productionOrderNumber: 'PRD-2024-001',
    workOrderId: 'wo-002',
    workOrderNumber: 'WO-2024-001-2',
    stageName: 'Casting & Cutting',
    workCenterId: 'wc-001',
    workCenterName: 'Cutting Area',
    machineId: 'mc-001',
    machineName: 'CNC Machine 1',
    operatorId: 'op-001',
    operatorName: 'Ramesh Yadav',
    shiftId: 'sh-001',
    shiftName: 'Morning',
    date: '2024-04-17',
    producedQty: 2,
    rejectedQty: 0,
    unit: 'Pcs',
    startTime: '06:00',
    endTime: '08:30',
    actualTimeMinutes: 150,
    notes: null,
    enteredBy: 'op-001',
    supervisorId: null,
    supervisorName: 'Meena Devi',
    isApproved: true,
    createdAt: '2024-04-17T08:45:00Z',
  },
  {
    id: 'pe-003',
    entryNumber: 'PE-2024-003',
    productionOrderId: 'prod-001',
    productionOrderNumber: 'PRD-2024-001',
    workOrderId: 'wo-003',
    workOrderNumber: 'WO-2024-001-3',
    stageName: 'Machining',
    workCenterId: 'wc-001',
    workCenterName: 'Cutting Area',
    machineId: 'mc-004',
    machineName: 'Hydraulic Press 2',
    operatorId: 'op-001',
    operatorName: 'Ramesh Yadav',
    shiftId: 'sh-001',
    shiftName: 'Morning',
    date: '2024-04-18',
    producedQty: 2,
    rejectedQty: 0,
    unit: 'Pcs',
    startTime: '06:00',
    endTime: '14:00',
    actualTimeMinutes: 480,
    notes: null,
    enteredBy: 'op-001',
    supervisorId: null,
    supervisorName: null,
    isApproved: false,
    createdAt: '2024-04-18T14:30:00Z',
  },
  {
    id: 'pe-004',
    entryNumber: 'PE-2024-004',
    productionOrderId: 'prod-001',
    productionOrderNumber: 'PRD-2024-001',
    workOrderId: 'wo-003',
    workOrderNumber: 'WO-2024-001-3',
    stageName: 'Machining',
    workCenterId: 'wc-001',
    workCenterName: 'Cutting Area',
    machineId: 'mc-004',
    machineName: 'Hydraulic Press 2',
    operatorId: 'op-001',
    operatorName: 'Ramesh Yadav',
    shiftId: 'sh-001',
    shiftName: 'Morning',
    date: '2024-04-19',
    producedQty: 0,
    rejectedQty: 1,
    unit: 'Pcs',
    startTime: '06:00',
    endTime: '08:00',
    actualTimeMinutes: 120,
    notes: 'Machine calibration issue',
    enteredBy: 'op-001',
    supervisorId: null,
    supervisorName: null,
    isApproved: false,
    createdAt: '2024-04-19T08:15:00Z',
  },
  {
    id: 'pe-005',
    entryNumber: 'PE-2024-005',
    productionOrderId: 'prod-003',
    productionOrderNumber: 'PRD-2024-003',
    workOrderId: 'wo-006',
    workOrderNumber: 'WO-2024-001-6',
    stageName: 'Packing',
    workCenterId: 'wc-003',
    workCenterName: 'Packing Zone',
    machineId: null,
    machineName: null,
    operatorId: 'op-003',
    operatorName: 'Anita Sharma',
    shiftId: 'sh-002',
    shiftName: 'Afternoon',
    date: '2024-04-09',
    producedQty: 10,
    rejectedQty: 1,
    unit: 'Pcs',
    startTime: '14:00',
    endTime: '18:00',
    actualTimeMinutes: 240,
    notes: null,
    enteredBy: 'op-003',
    supervisorId: null,
    supervisorName: null,
    isApproved: true,
    createdAt: '2024-04-09T18:30:00Z',
  },
];

export let mockProductionOrders: MockProductionOrder[] = [
  {
    id: 'prod-001',
    poNumber: 'PRD-2024-001',
    type: 'MTO',
    status: 'IN_PROGRESS',
    priority: 'HIGH',
    productId: 'itm-v001',
    productName: 'Industrial Pump X',
    productCode: 'ITM-0303-100',
    isVariant: true,
    variantName: 'Pump X-100 (100 LPM)',
    bomId: 'bom-v001',
    bomVersion: '1.0',
    plannedQty: 5,
    qty_to_produce: 5,
    completedQty: 2,
    completed_qty: 2,
    rejectedQty: 0,
    unit: 'Pcs',
    plannedStartDate: '2024-04-15',
    plannedEndDate: '2024-04-25',
    actualStartDate: '2024-04-15',
    actualEndDate: null,
    salesOrderRef: 'INV-2024-003',
    salesOrderId: 'si-003',
    warehouseId: 'wh-005',
    warehouseName: 'Manufacturing Plant',
    routingId: 'rt-001',
    routing_id: 'rt-001',
    workOrders: [
      { id: 'wo-001-1', woNumber: 'WO-001-1', wo_number: 'WO-001-1', stageNumber: 1, stage_number: 1, stageName: 'CNC Machining', stage_name: 'CNC Machining', status: 'COMPLETED' },
      { id: 'wo-001-2', woNumber: 'WO-001-2', wo_number: 'WO-001-2', stageNumber: 2, stage_number: 2, stageName: 'Sub-Assembly', stage_name: 'Sub-Assembly', status: 'COMPLETED' },
      { id: 'wo-001-3', woNumber: 'WO-001-3', wo_number: 'WO-001-3', stageNumber: 3, stage_number: 3, stageName: 'Winding & Core Assembly', stage_name: 'Winding & Core Assembly', status: 'IN_PROGRESS' },
      { id: 'wo-001-4', woNumber: 'WO-001-4', wo_number: 'WO-001-4', stageNumber: 4, stage_number: 4, stageName: 'Testing & QC', stage_name: 'Testing & QC', status: 'PENDING' },
    ],
    work_orders: [
      { id: 'wo-001-1', woNumber: 'WO-001-1', wo_number: 'WO-001-1', stageNumber: 1, stage_number: 1, stageName: 'CNC Machining', stage_name: 'CNC Machining', status: 'COMPLETED' },
      { id: 'wo-001-2', woNumber: 'WO-001-2', wo_number: 'WO-001-2', stageNumber: 2, stage_number: 2, stageName: 'Sub-Assembly', stage_name: 'Sub-Assembly', status: 'COMPLETED' },
      { id: 'wo-001-3', woNumber: 'WO-001-3', wo_number: 'WO-001-3', stageNumber: 3, stage_number: 3, stageName: 'Winding & Core Assembly', stage_name: 'Winding & Core Assembly', status: 'IN_PROGRESS' },
      { id: 'wo-001-4', woNumber: 'WO-001-4', wo_number: 'WO-001-4', stageNumber: 4, stage_number: 4, stageName: 'Testing & QC', stage_name: 'Testing & QC', status: 'PENDING' },
    ],
    notes: null,
    createdBy: 'Admin User',
    createdAt: '2024-04-14T09:00:00Z',
  },
  {
    id: 'prod-002',
    poNumber: 'PRD-2024-002',
    type: 'MTS',
    status: 'PLANNED',
    priority: 'NORMAL',
    productId: 'itm-v002',
    productName: 'Industrial Pump X',
    productCode: 'ITM-0303-200',
    isVariant: true,
    variantName: 'Pump X-200 (200 LPM)',
    bomId: 'bom-v002',
    bomVersion: '1.0',
    plannedQty: 3,
    qty_to_produce: 3,
    completedQty: 0,
    completed_qty: 0,
    rejectedQty: 0,
    unit: 'Pcs',
    plannedStartDate: '2024-04-28',
    plannedEndDate: '2024-05-05',
    actualStartDate: null,
    actualEndDate: null,
    salesOrderRef: null,
    salesOrderId: null,
    warehouseId: 'wh-005',
    warehouseName: 'Manufacturing Plant',
    routingId: 'rt-001',
    routing_id: 'rt-001',
    workOrders: [
      { id: 'wo-002-1', woNumber: 'WO-002-1', wo_number: 'WO-002-1', stageNumber: 1, stage_number: 1, stageName: 'CNC Machining', stage_name: 'CNC Machining', status: 'PENDING' },
      { id: 'wo-002-2', woNumber: 'WO-002-2', wo_number: 'WO-002-2', stageNumber: 2, stage_number: 2, stageName: 'Sub-Assembly', stage_name: 'Sub-Assembly', status: 'PENDING' },
      { id: 'wo-002-3', woNumber: 'WO-002-3', wo_number: 'WO-002-3', stageNumber: 3, stage_number: 3, stageName: 'Winding & Core Assembly', stage_name: 'Winding & Core Assembly', status: 'PENDING' },
      { id: 'wo-002-4', woNumber: 'WO-002-4', wo_number: 'WO-002-4', stageNumber: 4, stage_number: 4, stageName: 'Testing & QC', stage_name: 'Testing & QC', status: 'PENDING' },
    ],
    work_orders: [
      { id: 'wo-002-1', woNumber: 'WO-002-1', wo_number: 'WO-002-1', stageNumber: 1, stage_number: 1, stageName: 'CNC Machining', stage_name: 'CNC Machining', status: 'PENDING' },
      { id: 'wo-002-2', woNumber: 'WO-002-2', wo_number: 'WO-002-2', stageNumber: 2, stage_number: 2, stageName: 'Sub-Assembly', stage_name: 'Sub-Assembly', status: 'PENDING' },
      { id: 'wo-002-3', woNumber: 'WO-002-3', wo_number: 'WO-002-3', stageNumber: 3, stage_number: 3, stageName: 'Winding & Core Assembly', stage_name: 'Winding & Core Assembly', status: 'PENDING' },
      { id: 'wo-002-4', woNumber: 'WO-002-4', wo_number: 'WO-002-4', stageNumber: 4, stage_number: 4, stageName: 'Testing & QC', stage_name: 'Testing & QC', status: 'PENDING' },
    ],
    notes: 'Replenish stock to min level',
    createdBy: 'Admin User',
    createdAt: '2024-04-20T10:00:00Z',
  },
  {
    id: 'prod-003',
    poNumber: 'PRD-2024-003',
    type: 'MTO',
    status: 'COMPLETED',
    priority: 'NORMAL',
    productId: 'itm-017',
    productName: 'Gear Assembly A',
    productCode: 'ITM-0302',
    isVariant: false,
    variantName: null,
    bomId: 'bom_pending',
    bomVersion: '0.1',
    plannedQty: 10,
    qty_to_produce: 10,
    completedQty: 10,
    completed_qty: 10,
    rejectedQty: 1,
    unit: 'Pcs',
    plannedStartDate: '2024-04-01',
    plannedEndDate: '2024-04-10',
    actualStartDate: '2024-04-01',
    actualEndDate: '2024-04-09',
    salesOrderRef: 'INV-2024-001',
    salesOrderId: 'si-001',
    warehouseId: 'wh-005',
    warehouseName: 'Manufacturing Plant',
    routingId: 'rt-002',
    routing_id: 'rt-002',
    workOrders: [
      { id: 'wo-003-1', woNumber: 'WO-003-1', wo_number: 'WO-003-1', stageNumber: 1, stage_number: 1, stageName: 'Gear Hobbing', stage_name: 'Gear Hobbing', status: 'COMPLETED' },
      { id: 'wo-003-2', woNumber: 'WO-003-2', wo_number: 'WO-003-2', stageNumber: 2, stage_number: 2, stageName: 'Heat Treatment', stage_name: 'Heat Treatment', status: 'COMPLETED' },
      { id: 'wo-003-3', woNumber: 'WO-003-3', wo_number: 'WO-003-3', stageNumber: 3, stage_number: 3, stageName: 'Assembly', stage_name: 'Assembly', status: 'COMPLETED' },
      { id: 'wo-003-4', woNumber: 'WO-003-4', wo_number: 'WO-003-4', stageNumber: 4, stage_number: 4, stageName: 'Final Testing', stage_name: 'Final Testing', status: 'COMPLETED' },
    ],
    work_orders: [
      { id: 'wo-003-1', woNumber: 'WO-003-1', wo_number: 'WO-003-1', stageNumber: 1, stage_number: 1, stageName: 'Gear Hobbing', stage_name: 'Gear Hobbing', status: 'COMPLETED' },
      { id: 'wo-003-2', woNumber: 'WO-003-2', wo_number: 'WO-003-2', stageNumber: 2, stage_number: 2, stageName: 'Heat Treatment', stage_name: 'Heat Treatment', status: 'COMPLETED' },
      { id: 'wo-003-3', woNumber: 'WO-003-3', wo_number: 'WO-003-3', stageNumber: 3, stage_number: 3, stageName: 'Assembly', stage_name: 'Assembly', status: 'COMPLETED' },
      { id: 'wo-003-4', woNumber: 'WO-003-4', wo_number: 'WO-003-4', stageNumber: 4, stage_number: 4, stageName: 'Final Testing', stage_name: 'Final Testing', status: 'COMPLETED' },
    ],
    notes: null,
    createdBy: 'Admin User',
    createdAt: '2024-03-30T08:00:00Z',
  },
  {
    id: 'prod-004',
    poNumber: 'PRD-2024-004',
    type: 'MTS',
    status: 'IN_PROGRESS',
    priority: 'LOW',
    productId: 'itm-v001',
    productName: 'Industrial Pump X',
    productCode: 'ITM-0303-100',
    isVariant: true,
    variantName: 'Pump X-100 (100 LPM)',
    bomId: 'bom-v001',
    bomVersion: '1.0',
    plannedQty: 5,
    qty_to_produce: 5,
    completedQty: 3,
    completed_qty: 3,
    rejectedQty: 0,
    unit: 'Pcs',
    plannedStartDate: '2024-05-10',
    plannedEndDate: '2024-05-15',
    actualStartDate: null,
    actualEndDate: null,
    salesOrderRef: null,
    salesOrderId: null,
    warehouseId: 'wh-005',
    warehouseName: 'Manufacturing Plant',
    routingId: null,
    routing_id: null,
    workOrders: [],
    work_orders: [],
    notes: null,
    createdBy: 'Admin User',
    createdAt: '2024-04-25T11:00:00Z',
  },
  {
    id: 'prod-005',
    poNumber: 'PRD-2024-005',
    type: 'MTO',
    status: 'ON_HOLD',
    priority: 'URGENT',
    productId: 'itm-v002',
    productName: 'Industrial Pump X',
    productCode: 'ITM-0303-200',
    isVariant: true,
    variantName: 'Pump X-200 (200 LPM)',
    bomId: 'bom-v002',
    bomVersion: '1.0',
    plannedQty: 4,
    qty_to_produce: 4,
    completedQty: 0,
    completed_qty: 0,
    rejectedQty: 0,
    unit: 'Pcs',
    plannedStartDate: '2024-04-20',
    plannedEndDate: '2024-04-30',
    actualStartDate: '2024-04-20',
    actualEndDate: null,
    salesOrderRef: 'INV-2024-002',
    salesOrderId: 'si-002',
    warehouseId: 'wh-005',
    warehouseName: 'Manufacturing Plant',
    routingId: null,
    routing_id: null,
    workOrders: [],
    work_orders: [],
    notes: 'Material shortage — on hold',
    createdBy: 'Admin User',
    createdAt: '2024-04-18T14:00:00Z',
  },
];

// ─── Warehouses ───────────────────────────────────────────────────────────────
export const mockWarehouses = [
  { id: 'wh-001', name: 'Main Warehouse', type: 'GODOWN' as const, address: '204, Tech Park, Baner, Pune 411045', inchargeName: 'Suresh Patil', inchargePhone: '9876543210', isActive: true, itemCount: 128, totalValue: 4820000 },
  { id: 'wh-002', name: 'North Branch', type: 'BRANCH' as const, address: '12, Industrial Area, Pimpri, Pune 411018', inchargeName: 'Kavita Rao', inchargePhone: '9876543211', isActive: true, itemCount: 64, totalValue: 1940000 },
  { id: 'wh-003', name: 'South Depot', type: 'GODOWN' as const, address: '89, MIDC, Hadapsar, Pune 411028', inchargeName: 'Mohan Das', inchargePhone: '9876543212', isActive: true, itemCount: 45, totalValue: 1220000 },
  { id: 'wh-004', name: 'Head Office', type: 'OFFICE' as const, address: '501, Baner Road, Pune 411045', inchargeName: 'Anita Singh', inchargePhone: '9876543213', isActive: true, itemCount: 12, totalValue: 380000 },
  { id: 'wh-005', name: 'Manufacturing Plant', type: 'FACTORY' as const, address: 'Plot 22, MIDC Chakan, Pune 410501', inchargeName: 'Rajesh Nair', inchargePhone: '9876543214', isActive: true, itemCount: 210, totalValue: 8640000 },
  { id: 'wh-006', name: 'Retail Store', type: 'STORE' as const, address: '14, FC Road, Pune 411004', inchargeName: 'Priya Mehta', inchargePhone: '9876543215', isActive: true, itemCount: 88, totalValue: 2160000 },
];

// ─── Parties ──────────────────────────────────────────────────────────────────
export const mockParties = [
  { id: 'pty-001', name: 'Ramesh Electronics', type: 'CUSTOMER' as const, gstin: '27AADCR4849M1ZV', pan: 'AADCR4849M', phone: '9812345670', email: 'ramesh@electronics.in', billingAddress: '45, MG Road, Pune 411001', shippingAddress: '45, MG Road, Pune 411001', stateCode: '27', stateName: 'Maharashtra', creditLimit: 600000, creditDays: 30, openingBalance: 12500, isActive: true, balance: 28400 },
  { id: 'pty-002', name: 'TechSupply Co.', type: 'SUPPLIER' as const, gstin: '29AACCT3428D1Z2', pan: 'AACCT3428D', phone: '9823456780', email: 'purchase@techsupply.com', billingAddress: '18, Industrial Area, Bengaluru 560095', shippingAddress: '18, Industrial Area, Bengaluru 560095', stateCode: '29', stateName: 'Karnataka', creditLimit: 1000000, creditDays: 45, openingBalance: 0, isActive: true, balance: -146000 },
  { id: 'pty-003', name: 'Global IT Solutions', type: 'BOTH' as const, gstin: '07AABCG5678H1ZP', pan: 'AABCG5678H', phone: '9834567890', email: 'billing@globalit.in', billingAddress: 'B-24, Sector 18, Noida 201301', shippingAddress: 'B-24, Sector 18, Noida 201301', stateCode: '07', stateName: 'Delhi', creditLimit: 760000, creditDays: 30, openingBalance: 6000, isActive: true, balance: 67200 },
  { id: 'pty-004', name: 'Priya Computers', type: 'CUSTOMER' as const, gstin: '27AAACP1234Q1ZA', pan: 'AAACP1234Q', phone: '9845678901', email: 'priya@computers.in', billingAddress: '7, Laxmi Road, Pune 411030', shippingAddress: '7, Laxmi Road, Pune 411030', stateCode: '27', stateName: 'Maharashtra', creditLimit: 260000, creditDays: 15, openingBalance: 0, isActive: true, balance: 18900 },
  { id: 'pty-005', name: 'NexGen Components', type: 'SUPPLIER' as const, gstin: '33AABCN9012E1ZK', pan: 'AABCN9012E', phone: '9856789012', email: 'sales@nexgen.in', billingAddress: '103, Anna Salai, Chennai 600002', shippingAddress: '103, Anna Salai, Chennai 600002', stateCode: '33', stateName: 'Tamil Nadu', creditLimit: 2000000, creditDays: 60, openingBalance: 0, isActive: true, balance: -320000 },
  { id: 'pty-006', name: 'Apex Hardware', type: 'CUSTOMER' as const, gstin: '06AABCA5432F1ZX', pan: 'AABCA5432F', phone: '9867890123', email: 'apex@hardware.in', billingAddress: 'Plot 12, Gurgaon Industrial Area 122001', shippingAddress: 'Plot 12, Gurgaon Industrial Area 122001', stateCode: '06', stateName: 'Haryana', creditLimit: 400000, creditDays: 30, openingBalance: 8000, isActive: false, balance: 0 },
];

// ─── Categories ───────────────────────────────────────────────────────────────
export const mockCategories = [
  { id: 'cat-001', name: 'Electronics', parentId: null, parentName: null, itemCount: 42, isActive: true, requiresNarration: true },
  { id: 'cat-002', name: 'Accessories', parentId: null, parentName: null, itemCount: 87, isActive: true, requiresNarration: false },
  { id: 'cat-003', name: 'Laptops & Desktops', parentId: 'cat-001', parentName: 'Electronics', itemCount: 18, isActive: true, requiresNarration: true },
  { id: 'cat-004', name: 'Monitors & Displays', parentId: 'cat-001', parentName: 'Electronics', itemCount: 12, isActive: true, requiresNarration: true },
  { id: 'cat-005', name: 'Keyboards & Mice', parentId: 'cat-002', parentName: 'Accessories', itemCount: 24, isActive: true, requiresNarration: false },
  { id: 'cat-006', name: 'Cables & Adapters', parentId: 'cat-002', parentName: 'Accessories', itemCount: 31, isActive: true, requiresNarration: false },
  { id: 'cat-007', name: 'Storage', parentId: 'cat-001', parentName: 'Electronics', itemCount: 22, isActive: true, requiresNarration: true },
  { id: 'cat-008', name: 'Networking', parentId: null, parentName: null, itemCount: 15, isActive: true, requiresNarration: false },
  { id: 'cat-009', name: 'Printers & Scanners', parentId: null, parentName: null, itemCount: 9, isActive: true, requiresNarration: false },
  { id: 'cat-010', name: 'Server & UPS', parentId: 'cat-001', parentName: 'Electronics', itemCount: 6, isActive: true, requiresNarration: true },
];

// ─── Warehouse Stock ──────────────────────────────────────────────────────────
// Per-warehouse stock levels for each item
export const mockWarehouseStock: Record<string, Record<string, number>> = {
  'wh-001': {
    'itm-001': 500, 'itm-002': 500, 'itm-003': 500, 'itm-004': 450,
    'itm-005': 4, 'itm-006': 3, 'itm-007': 600, 'itm-008': 2,
    'itm-009': 670, 'itm-010': 540, 'itm-011': 290, 'itm-012': 160,
    'itm-013': 0, 'itm-014': 0, 'itm-015': 0,
    'itm-0303': 0, 'itm-v002': 2, 'itm-0303-500': 1,
    'itm-0500': 3, 'itm-0501': 0, 'itm-0502': 8,
    'item-rm-001': 500, 'item-rm-002': 500, 'item-rm-003': 500,
    'item-1': 500, 'item-2': 500, 'item-3': 500,
    'RM-STL-001': 500, 'RM-COP-002': 500, 'RM-CAS-003': 500,
  },
  'wh-002': {
    'itm-001': 120, 'itm-002': 550, 'itm-003': 300, 'itm-004': 180,
    'itm-005': 100, 'itm-006': 80, 'itm-007': 220, 'itm-008': 50,
    'itm-009': 200, 'itm-010': 150, 'itm-011': 100, 'itm-012': 70,
    'item-rm-001': 500, 'item-rm-002': 500, 'item-rm-003': 500,
  },
  'wh-003': {
    'itm-001': 50, 'itm-002': 300, 'itm-003': 150, 'itm-004': 80,
    'itm-005': 20, 'itm-006': 10, 'itm-007': 100, 'itm-008': 40,
    'itm-009': 250, 'itm-010': 180, 'itm-011': 60, 'itm-012': 40,
    'item-rm-001': 500, 'item-rm-002': 500, 'item-rm-003': 500,
  },
  'wh-004': {
    'itm-001': 200, 'itm-002': 100, 'itm-003': 50, 'itm-004': 30,
    'itm-005': 10, 'itm-006': 20, 'itm-007': 80, 'itm-008': 10,
    'itm-009': 50, 'itm-010': 40, 'itm-011': 30, 'itm-012': 20,
    'item-rm-001': 500, 'item-rm-002': 500, 'item-rm-003': 500,
  },
  'wh-005': {
    'itm-001': 500, 'itm-002': 200, 'itm-003': 120, 'itm-004': 80,
    'itm-005': 150, 'itm-006': 250, 'itm-007': 600, 'itm-008': 120,
    'itm-009': 900, 'itm-010': 750, 'itm-011': 400, 'itm-012': 300,
    'item-rm-001': 500, 'item-rm-002': 500, 'item-rm-003': 500,
  },
  'wh-006': {
    'itm-001': 80, 'itm-002': 450, 'itm-003': 220, 'itm-004': 150,
    'itm-005': 30, 'itm-006': 120, 'itm-007': 180, 'itm-008': 40,
    'itm-009': 300, 'itm-010': 220, 'itm-011': 140, 'itm-012': 90,
    'item-rm-001': 500, 'item-rm-002': 500, 'item-rm-003': 500,
  },
};

// ─── Units ────────────────────────────────────────────────────────────────────
export const mockUnits = [
  { id: 'unt-001', name: 'Pieces', shortName: 'Pcs', isActive: true, itemCount: 142 },
  { id: 'unt-002', name: 'Kilograms', shortName: 'Kg', isActive: true, itemCount: 12 },
  { id: 'unt-003', name: 'Litres', shortName: 'Ltr', isActive: true, itemCount: 8 },
  { id: 'unt-004', name: 'Boxes', shortName: 'Box', isActive: true, itemCount: 34 },
  { id: 'unt-005', name: 'Meters', shortName: 'Mtr', isActive: true, itemCount: 6 },
  { id: 'unt-006', name: 'Pairs', shortName: 'Pr', isActive: true, itemCount: 4 },
  { id: 'unt-007', name: 'Sets', shortName: 'Set', isActive: true, itemCount: 18 },
  { id: 'unt-008', name: 'Rolls', shortName: 'Roll', isActive: false, itemCount: 0 },
];

// ─── Items ────────────────────────────────────────────────────────────────────
export const mockItems: MockItem[] = [
  { id: 'itm-001', name: 'Laptop 15" Core i7', code: 'ITM-0001', barcode: '8901234567890', companyBarcode: '8901234567890', categoryId: 'cat-003', categoryName: 'Laptops & Desktops', hsnCode: '84713010', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 72000, saleRate: 86000, mrp: 90000, minStockLevel: 10, stock: 38, isActive: true, size: '15"', group: 'Laptops', brand: 'Generic', articleNo: 'LPT-I7-001', color: 'Silver', markUpPct: 18, purExpPct: 2, saleDisPct: 5 },
  { id: 'itm-002', name: 'Wireless Mouse Logitech M235', code: 'ITM-0002', barcode: '7612345678901', companyBarcode: '7612345678901', categoryId: 'cat-005', categoryName: 'Keyboards & Mice', hsnCode: '84716060', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 850, saleRate: 1200, mrp: 1499, minStockLevel: 20, stock: 124, isActive: true, size: 'Standard', group: 'Peripherals', brand: 'Logitech', articleNo: 'M235-BLK', color: 'Black', markUpPct: 41, purExpPct: 1, saleDisPct: 10 },
  { id: 'itm-003', name: 'USB-C 7-in-1 Hub', code: 'ITM-0003', barcode: '7623456789012', companyBarcode: '7623456789012', categoryId: 'cat-006', categoryName: 'Cables & Adapters', hsnCode: '85444290', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 1200, saleRate: 1800, mrp: 2199, minStockLevel: 15, stock: 89, isActive: true, size: 'Universal', group: 'Adapters', brand: 'Anker', articleNo: 'HUB-7IN1', color: 'Gray', markUpPct: 50, purExpPct: 1, saleDisPct: 8 },
  { id: 'itm-004', name: 'Mechanical Keyboard RGB', code: 'ITM-0004', barcode: '7634567890123', companyBarcode: '7634567890123', categoryId: 'cat-005', categoryName: 'Keyboards & Mice', hsnCode: '84716060', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 5500, saleRate: 7500, mrp: 8999, minStockLevel: 10, stock: 45, isActive: true, size: 'Full Size', group: 'Peripherals', brand: 'Corsair', articleNo: 'KB-RGB-001', color: 'Black', markUpPct: 36, purExpPct: 1, saleDisPct: 5 },
  { id: 'itm-005', name: 'Monitor 24" Full HD IPS', code: 'ITM-0045', barcode: '8645678901234', companyBarcode: '8645678901234', categoryId: 'cat-004', categoryName: 'Monitors & Displays', hsnCode: '85285200', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 12000, saleRate: 16000, mrp: 17999, minStockLevel: 10, reorderPoint: 10, reorderQty: 15, stock: 4, isActive: true, itemType: 'FINISHED_GOOD', size: '24"', group: 'Monitors', brand: 'LG', articleNo: 'MON-24FHD', color: 'Black', markUpPct: 25, purExpPct: 2, saleDisPct: 5 },
  { id: 'itm-006', name: 'Laptop Bag 15.6" Waterproof', code: 'ITM-0078', barcode: '8656789012345', companyBarcode: '8656789012345', categoryId: 'cat-002', categoryName: 'Accessories', hsnCode: '42021200', taxRate: 12, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 800, saleRate: 1200, mrp: 1499, minStockLevel: 15, reorderPoint: 15, reorderQty: 30, stock: 3, isActive: true, itemType: 'FINISHED_GOOD', size: '15.6"', group: 'Bags', brand: 'Wildcraft', articleNo: 'BAG-156-WP', color: 'Black', markUpPct: 50, purExpPct: 1, saleDisPct: 10 },
  { id: 'itm-007', name: 'HDMI Cable 2m v2.0', code: 'ITM-0112', barcode: '8667890123456', companyBarcode: '8667890123456', categoryId: 'cat-006', categoryName: 'Cables & Adapters', hsnCode: '85444290', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 150, saleRate: 250, mrp: 399, minStockLevel: 25, stock: 6, isActive: true, size: '2m', group: 'Cables', brand: 'Belkin', articleNo: 'HDMI-2M-V2', color: 'Black', markUpPct: 67, purExpPct: 0, saleDisPct: 5 },
  { id: 'itm-008', name: 'Network Switch 8-Port', code: 'ITM-0150', barcode: '8678901234567', companyBarcode: '8678901234567', categoryId: 'cat-008', categoryName: 'Networking', hsnCode: '85176200', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 3200, saleRate: 4500, mrp: 5499, minStockLevel: 5, reorderPoint: 5, reorderQty: 10, stock: 2, isActive: true, itemType: 'FINISHED_GOOD', size: '8-Port', group: 'Networking', brand: 'TP-Link', articleNo: 'SW-8P-100', color: 'Gray', markUpPct: 41, purExpPct: 1, saleDisPct: 5 },
  { id: 'itm-009', name: 'SSD 1TB NVMe Samsung', code: 'ITM-0200', barcode: '8689012345678', companyBarcode: '8689012345678', categoryId: 'cat-007', categoryName: 'Storage', hsnCode: '84717010', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 6500, saleRate: 8500, mrp: 9999, minStockLevel: 20, stock: 67, isActive: true, size: '1TB', group: 'Storage', brand: 'Samsung', articleNo: '980PRO-1TB', color: 'Black', markUpPct: 31, purExpPct: 1, saleDisPct: 5 },
  { id: 'itm-010', name: 'RAM 16GB DDR5 3200MHz', code: 'ITM-0201', barcode: '8690123456789', companyBarcode: '8690123456789', categoryId: 'cat-007', categoryName: 'Storage', hsnCode: '84717010', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 4800, saleRate: 6200, mrp: 7499, minStockLevel: 15, stock: 54, isActive: true, size: '16GB', group: 'Memory', brand: 'Corsair', articleNo: 'RAM-16G-D5', color: 'Black', markUpPct: 29, purExpPct: 1, saleDisPct: 5 },
  { id: 'itm-011', name: 'Webcam 1080p with Mic', code: 'ITM-0222', barcode: '8601234567890', companyBarcode: '8601234567890', categoryId: 'cat-002', categoryName: 'Accessories', hsnCode: '85258090', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 1800, saleRate: 2500, mrp: 2999, minStockLevel: 12, stock: 29, isActive: true, size: 'Standard', group: 'Webcams', brand: 'Logitech', articleNo: 'CAM-1080P', color: 'Black', markUpPct: 39, purExpPct: 1, saleDisPct: 8 },
  { id: 'itm-012', name: 'Wi-Fi 6 Router AX1800', code: 'ITM-0230', barcode: '8612345678901', companyBarcode: '8612345678901', categoryId: 'cat-008', categoryName: 'Networking', hsnCode: '85176200', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 4200, saleRate: 5800, mrp: 6999, minStockLevel: 8, stock: 16, isActive: true, size: 'AX1800', group: 'Routers', brand: 'TP-Link', articleNo: 'RTR-AX1800', color: 'White', markUpPct: 38, purExpPct: 1, saleDisPct: 5 },
  // Items without barcode (to show disabled state in Barcode Management)
  { id: 'itm-013', name: 'USB 3.0 Flash Drive 64GB', code: 'ITM-0240', barcode: null, companyBarcode: null, categoryId: 'cat-007', categoryName: 'Storage', hsnCode: '84717010', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 350, saleRate: 550, mrp: 699, minStockLevel: 30, reorderPoint: 30, reorderQty: 50, stock: 0, isActive: true, itemType: 'FINISHED_GOOD', size: '64GB', group: 'Storage', brand: 'SanDisk', articleNo: 'FD-64G-USB3', color: 'Black', markUpPct: 57, purExpPct: 0, saleDisPct: 5 },
  { id: 'itm-014', name: 'Bluetooth Speaker Portable', code: 'ITM-0241', barcode: null, companyBarcode: null, categoryId: 'cat-002', categoryName: 'Accessories', hsnCode: '85182100', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 1500, saleRate: 2200, mrp: 2799, minStockLevel: 10, reorderPoint: 10, reorderQty: 20, stock: 0, isActive: true, itemType: 'FINISHED_GOOD', size: 'Portable', group: 'Audio', brand: 'JBL', articleNo: 'SPK-BT-001', color: 'Blue', markUpPct: 47, purExpPct: 1, saleDisPct: 8 },
  { id: 'itm-015', name: 'Laptop Cooling Pad', code: 'ITM-0242', barcode: null, companyBarcode: null, categoryId: 'cat-002', categoryName: 'Accessories', hsnCode: '84145990', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 600, saleRate: 950, mrp: 1199, minStockLevel: 15, reorderPoint: 15, reorderQty: 25, stock: 0, isActive: true, itemType: 'FINISHED_GOOD', size: 'Universal', group: 'Accessories', brand: 'Havit', articleNo: 'COOL-PAD-001', color: 'Black', markUpPct: 58, purExpPct: 0, saleDisPct: 5 },
  { id: 'itm-0303', name: 'Industrial Pump X', code: 'ITM-0303', barcode: null, companyBarcode: null, categoryId: 'cat-001', categoryName: 'Industrial', hsnCode: '84137010', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 15000, saleRate: 22000, mrp: 25000, minStockLevel: 2, reorderPoint: 2, reorderQty: 3, stock: 0, isActive: true, itemType: 'FINISHED_GOOD', bomId: 'bom-0303', group: 'Pumps' },
  { id: 'itm-v002', name: 'Industrial Pump X-200', code: 'ITM-0303-200', barcode: null, companyBarcode: null, categoryId: 'cat-001', categoryName: 'Industrial', hsnCode: '84137010', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 18000, saleRate: 26000, mrp: 29000, minStockLevel: 2, reorderPoint: 2, reorderQty: 3, stock: 2, isActive: true, isVariant: true, variantName: 'Pump X-200', itemType: 'FINISHED_GOOD', bomId: 'bom-v002', group: 'Pumps' },
  { id: 'itm-0303-500', name: 'Industrial Pump X-500', code: 'ITM-0303-500', barcode: null, companyBarcode: null, categoryId: 'cat-001', categoryName: 'Industrial', hsnCode: '84137010', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 24000, saleRate: 34000, mrp: 38000, minStockLevel: 1, reorderPoint: 1, reorderQty: 2, stock: 1, isActive: true, isVariant: true, variantName: 'Pump X-500', itemType: 'FINISHED_GOOD', bomId: 'bom-0303-500', group: 'Pumps' },
  { id: 'itm-0500', name: 'HP-500 Pump', code: 'ITM-0500', barcode: null, companyBarcode: null, categoryId: 'cat-001', categoryName: 'Industrial', hsnCode: '84137010', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 14000, saleRate: 21000, mrp: 24000, minStockLevel: 10, reorderPoint: 10, reorderQty: 20, stock: 3, isActive: true, itemType: 'FINISHED_GOOD', bomId: 'bom-hp-500', bomVersion: '1.0', group: 'Pumps' },
  { id: 'itm-0501', name: 'Gear Box A', code: 'ITM-0501', barcode: null, companyBarcode: null, categoryId: 'cat-001', categoryName: 'Industrial', hsnCode: '84834000', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 8000, saleRate: 12000, mrp: 14000, minStockLevel: 5, reorderPoint: 5, reorderQty: 15, stock: 0, isActive: true, itemType: 'FINISHED_GOOD', bomId: 'bom-gear-box', bomVersion: '1.0', group: 'Assemblies' },
  { id: 'itm-0502', name: 'Motor M-200', code: 'ITM-0502', barcode: null, companyBarcode: null, categoryId: 'cat-001', categoryName: 'Industrial', hsnCode: '85015210', taxRate: 18, unitId: 'unt-001', unitName: 'Pcs', purchaseRate: 11000, saleRate: 16500, mrp: 19000, minStockLevel: 15, reorderPoint: 15, reorderQty: 25, stock: 8, isActive: true, itemType: 'FINISHED_GOOD', bomId: 'bom-motor-200', bomVersion: '1.0', group: 'Motors' },
];

// ─── Roles ────────────────────────────────────────────────────────────────────
export const mockRoles = [
  {
    id: 'role-001',
    name: 'Billing Staff',
    description: 'Can create and edit sales invoices, challans, and view basic reports',
    isSystem: false,
    isActive: true,
    createdAt: '2024-04-01T00:00:00Z',
    createdBy: 'Admin User',
    usersAssigned: 2,
    permissions: {
      dashboard: { view: true },
      sales_invoice: { view: true, create: true, edit: true, delete: false },
      sale_return: { view: true, create: false, edit: false, delete: false },
      challan: { view: true, create: true, edit: true, delete: false },
      purchase_order: { view: false, create: false, edit: false, delete: false },
      purchase_invoice: { view: false, create: false, edit: false, delete: false },
      purchase_return: { view: false, create: false, edit: false, delete: false },
      stock_receiving: { view: false, create: false },
      stock_transfer: { view: false, create: false, edit: false, delete: false },
      stock_adjustment: { view: false, create: false },
      stock_entries: { view: false, create: false },
      grn_history: { view: false },
      parties: { view: true, create: false, edit: false, delete: false },
      items: { view: true, create: false, edit: false, delete: false },
      warehouses: { view: false, create: false, edit: false, delete: false },
      reports: { view: true },
      users: { view: false, create: false, edit: false, delete: false },
      settings: { view: false, edit: false },
    },
    additionalControls: {
      approveStockTransfer: false,
      approveStockAdjustment: false,
      viewAllWarehouses: false,
      exportData: false,
      viewFinancialReports: false,
      editLockedRecords: false,
      convertChallan: true,
      manageUserPermissions: false,
    },
  },
  {
    id: 'role-002',
    name: 'Warehouse Staff',
    description: 'Manages stock receiving, GRN, stock transfers and inventory view',
    isSystem: false,
    isActive: true,
    createdAt: '2024-04-01T00:00:00Z',
    createdBy: 'Admin User',
    usersAssigned: 3,
    permissions: {
      dashboard: { view: true },
      sales_invoice: { view: false, create: false, edit: false, delete: false },
      sale_return: { view: false, create: false, edit: false, delete: false },
      challan: { view: false, create: false, edit: false, delete: false },
      purchase_order: { view: true, create: false, edit: false, delete: false },
      purchase_invoice: { view: false, create: false, edit: false, delete: false },
      purchase_return: { view: false, create: false, edit: false, delete: false },
      stock_receiving: { view: true, create: true },
      stock_transfer: { view: true, create: true, edit: false, delete: false },
      stock_adjustment: { view: true, create: false },
      stock_entries: { view: true, create: true },
      grn_history: { view: true },
      parties: { view: true, create: false, edit: false, delete: false },
      items: { view: true, create: false, edit: false, delete: false },
      warehouses: { view: true, create: false, edit: false, delete: false },
      reports: { view: false },
      users: { view: false, create: false, edit: false, delete: false },
      settings: { view: false, edit: false },
    },
    additionalControls: {
      approveStockTransfer: false,
      approveStockAdjustment: false,
      viewAllWarehouses: false,
      exportData: false,
      viewFinancialReports: false,
      editLockedRecords: false,
      convertChallan: false,
      manageUserPermissions: false,
    },
  },
  {
    id: 'role-003',
    name: 'Accountant',
    description: 'View-only access to all modules, can export data and view financial reports',
    isSystem: false,
    isActive: true,
    createdAt: '2024-05-10T00:00:00Z',
    createdBy: 'Admin User',
    usersAssigned: 1,
    permissions: {
      dashboard: { view: true },
      sales_invoice: { view: true, create: false, edit: false, delete: false },
      sale_return: { view: true, create: false, edit: false, delete: false },
      challan: { view: true, create: false, edit: false, delete: false },
      purchase_order: { view: true, create: false, edit: false, delete: false },
      purchase_invoice: { view: true, create: false, edit: false, delete: false },
      purchase_return: { view: true, create: false, edit: false, delete: false },
      stock_receiving: { view: true, create: false },
      stock_transfer: { view: true, create: false, edit: false, delete: false },
      stock_adjustment: { view: true, create: false },
      stock_entries: { view: true, create: false },
      grn_history: { view: true },
      parties: { view: true, create: false, edit: false, delete: false },
      items: { view: true, create: false, edit: false, delete: false },
      warehouses: { view: true, create: false, edit: false, delete: false },
      reports: { view: true },
      users: { view: false, create: false, edit: false, delete: false },
      settings: { view: false, edit: false },
    },
    additionalControls: {
      approveStockTransfer: false,
      approveStockAdjustment: false,
      viewAllWarehouses: true,
      exportData: true,
      viewFinancialReports: true,
      editLockedRecords: false,
      convertChallan: false,
      manageUserPermissions: false,
    },
  },
  {
    id: 'role-004',
    name: 'Purchase Manager',
    description: 'Full access to all purchase modules, can approve stock transfers',
    isSystem: false,
    isActive: true,
    createdAt: '2024-06-01T00:00:00Z',
    createdBy: 'Admin User',
    usersAssigned: 1,
    permissions: {
      dashboard: { view: true },
      sales_invoice: { view: true, create: false, edit: false, delete: false },
      sale_return: { view: false, create: false, edit: false, delete: false },
      challan: { view: false, create: false, edit: false, delete: false },
      purchase_order: { view: true, create: true, edit: true, delete: true },
      purchase_invoice: { view: true, create: true, edit: true, delete: false },
      purchase_return: { view: true, create: true, edit: true, delete: false },
      stock_receiving: { view: true, create: true },
      stock_transfer: { view: true, create: true, edit: true, delete: false },
      stock_adjustment: { view: true, create: true },
      stock_entries: { view: true, create: false },
      grn_history: { view: true },
      parties: { view: true, create: true, edit: true, delete: false },
      items: { view: true, create: false, edit: false, delete: false },
      warehouses: { view: true, create: false, edit: false, delete: false },
      reports: { view: true },
      users: { view: false, create: false, edit: false, delete: false },
      settings: { view: false, edit: false },
    },
    additionalControls: {
      approveStockTransfer: true,
      approveStockAdjustment: true,
      viewAllWarehouses: true,
      exportData: false,
      viewFinancialReports: false,
      editLockedRecords: false,
      convertChallan: false,
      manageUserPermissions: false,
    },
  },
];

// ─── Users ────────────────────────────────────────────────────────────────────
export const mockUsers = [
  {
    id: 'usr-001',
    name: 'Admin User',
    email: 'admin@invenpro.com',
    phone: '9900000001',
    role: 'SUPER_ADMIN' as const,
    roleId: '',
    roleName: 'Super Admin',
    isSuperAdmin: true,
    warehouseIds: ['wh-001', 'wh-002', 'wh-003', 'wh-004', 'wh-005', 'wh-006'],
    assignedWarehouses: [
      { warehouseId: 'wh-001', warehouseName: 'Main Warehouse', warehouseType: 'GODOWN' as const, isPrimary: true },
      { warehouseId: 'wh-002', warehouseName: 'North Branch', warehouseType: 'BRANCH' as const, isPrimary: false },
      { warehouseId: 'wh-003', warehouseName: 'South Depot', warehouseType: 'GODOWN' as const, isPrimary: false },
      { warehouseId: 'wh-004', warehouseName: 'Head Office', warehouseType: 'OFFICE' as const, isPrimary: false },
      { warehouseId: 'wh-005', warehouseName: 'Manufacturing Plant', warehouseType: 'FACTORY' as const, isPrimary: false },
      { warehouseId: 'wh-006', warehouseName: 'Retail Store', warehouseType: 'STORE' as const, isPrimary: false },
    ],
    permissionOverrides: {},
    isActive: true,
    lastLoginAt: new Date().toISOString(),
    createdAt: '2024-04-01T00:00:00Z',
  },
  {
    id: 'usr-002',
    name: 'Priya Sharma',
    email: 'priya@invenpro.com',
    phone: '9912345678',
    role: 'END_USER' as const,
    roleId: 'role-001',
    roleName: 'Billing Staff',
    isSuperAdmin: false,
    warehouseIds: ['wh-001'],
    assignedWarehouses: [
      { warehouseId: 'wh-001', warehouseName: 'Main Warehouse', warehouseType: 'GODOWN' as const, isPrimary: true },
    ],
    permissionOverrides: {},
    isActive: true,
    lastLoginAt: new Date(Date.now() - 2 * 3600000).toISOString(),
    createdAt: '2024-04-01T00:00:00Z',
  },
  {
    id: 'usr-003',
    name: 'Raj Kumar',
    email: 'raj@invenpro.com',
    phone: '9823456789',
    role: 'END_USER' as const,
    roleId: 'role-002',
    roleName: 'Warehouse Staff',
    isSuperAdmin: false,
    warehouseIds: ['wh-001', 'wh-002'],
    assignedWarehouses: [
      { warehouseId: 'wh-001', warehouseName: 'Main Warehouse', warehouseType: 'GODOWN' as const, isPrimary: true },
      { warehouseId: 'wh-002', warehouseName: 'North Branch', warehouseType: 'BRANCH' as const, isPrimary: false },
    ],
    permissionOverrides: {},
    isActive: true,
    lastLoginAt: new Date(Date.now() - 86400000).toISOString(),
    createdAt: '2024-05-10T00:00:00Z',
  },
  {
    id: 'usr-004',
    name: 'Neha Singh',
    email: 'neha@invenpro.com',
    phone: '9734567890',
    role: 'END_USER' as const,
    roleId: 'role-003',
    roleName: 'Accountant',
    isSuperAdmin: false,
    warehouseIds: ['wh-001'],
    assignedWarehouses: [
      { warehouseId: 'wh-001', warehouseName: 'Main Warehouse', warehouseType: 'GODOWN' as const, isPrimary: true },
    ],
    permissionOverrides: {},
    isActive: true,
    lastLoginAt: new Date(Date.now() - 5 * 86400000).toISOString(),
    createdAt: '2024-06-15T00:00:00Z',
  },
  {
    id: 'usr-005',
    name: 'Amit Patel',
    email: 'amit@invenpro.com',
    phone: '9645678901',
    role: 'END_USER' as const,
    roleId: 'role-004',
    roleName: 'Purchase Manager',
    isSuperAdmin: false,
    warehouseIds: ['wh-001', 'wh-002', 'wh-003', 'wh-004', 'wh-005'],
    assignedWarehouses: [
      { warehouseId: 'wh-001', warehouseName: 'Main Warehouse', warehouseType: 'GODOWN' as const, isPrimary: true },
      { warehouseId: 'wh-002', warehouseName: 'North Branch', warehouseType: 'BRANCH' as const, isPrimary: false },
      { warehouseId: 'wh-003', warehouseName: 'South Depot', warehouseType: 'GODOWN' as const, isPrimary: false },
      { warehouseId: 'wh-004', warehouseName: 'Head Office', warehouseType: 'OFFICE' as const, isPrimary: false },
      { warehouseId: 'wh-005', warehouseName: 'Manufacturing Plant', warehouseType: 'FACTORY' as const, isPrimary: false },
    ],
    permissionOverrides: {},
    isActive: true,
    lastLoginAt: new Date(Date.now() - 3 * 3600000).toISOString(),
    createdAt: '2024-07-01T00:00:00Z',
  },
  {
    id: 'usr-006',
    name: 'Deepak Kumar',
    email: 'deepak@invenpro.com',
    phone: '9556789012',
    role: 'SUB_ADMIN' as const,
    roleId: '',
    roleName: 'Manager',
    isSuperAdmin: false,
    warehouseIds: ['wh-002', 'wh-003'],
    assignedWarehouses: [
      { warehouseId: 'wh-002', warehouseName: 'North Branch', warehouseType: 'BRANCH' as const, isPrimary: true },
      { warehouseId: 'wh-003', warehouseName: 'South Depot', warehouseType: 'GODOWN' as const, isPrimary: false },
    ],
    permissionOverrides: {},
    isActive: true,
    lastLoginAt: new Date(Date.now() - 12 * 3600000).toISOString(),
    createdAt: '2024-08-20T00:00:00Z',
  },
];

// ─── Manufacturing Mock Data ──────────────────────────────────────────────────

export interface MockItem {
  id: string;
  name: string;
  code: string;
  barcode: string | null;
  companyBarcode: string | null;
  categoryId: string;
  categoryName: string;
  hsnCode: string;
  taxRate: number;
  unitId: string;
  unitName: string;
  purchaseRate: number;
  saleRate: number;
  mrp: number;
  minStockLevel: number;
  stock: number;
  isActive: boolean;
  size?: string;
  group?: string;
  brand?: string;
  articleNo?: string;
  color?: string;
  markUpPct?: number;
  purExpPct?: number;
  saleDisPct?: number;
  itemType?: 'FINISHED_GOOD' | 'RAW_MATERIAL' | 'SEMI_FINISHED' | 'CONSUMABLE' | 'PACKAGING';
  reorderPoint?: number;
  reorderQty?: number;
  bomId?: string | null;
  leadTimeDays?: number;
  isVariant?: boolean;
  variantName?: string | null;
  standardCost?: number;
  bomVersion?: string;
  variantAttributes?: any;
}

export interface MockBOM {
  id: string;
  productId: string;
  status: string;
  version: string;
}

export interface MockBOMItem {
  id: string;
  bomId: string;
  level: number;
  itemId: string;
  itemName: string;
  itemCode: string;
  qtyPerUnit: number;
  effectiveQty: number;
  unit: string;
  parentId?: string | null;
  itemType?: string;
  standardCost?: number;
}

export interface MockWorkOrder {
  id: string;
  woNumber: string;
  productionOrderId: string;
  productionOrderNumber: string;
  stageNumber: number;
  stageName: string;
  workCenterId: string;
  workCenterName: string;
  machineId: string | null;
  machineName: string | null;
  plannedStartDate: string;
  plannedEndDate: string;
  plannedTimeMinutes: number;
  actualTimeMinutes?: number;
  status: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'ON_HOLD';
  completedQty: number;
  plannedQty: number;
  operatorId?: string | null;
  operatorName?: string | null;
}

export interface MockMachine {
  id: string;
  name: string;
  workCenterId: string;
  status: 'RUNNING' | 'IDLE' | 'MAINTENANCE' | 'BREAKDOWN';
  capacityPerHour: number;
}

export const mockWorkCenters = [
  { id: 'wc-001', name: 'Assembly Line A' },
  { id: 'wc-002', name: 'Fabrication & Welding' },
  { id: 'wc-003', name: 'Quality Inspection' },
  { id: 'wc-004', name: 'Packaging Section' },
];

export const mockMachines: MockMachine[] = [
  { id: 'mc-001', name: 'CNC Milling Machine', workCenterId: 'wc-002', status: 'RUNNING', capacityPerHour: 15 },
  { id: 'mc-002', name: 'Laser Cutter', workCenterId: 'wc-002', status: 'IDLE', capacityPerHour: 20 },
  { id: 'mc-003', name: 'Assembly Robot A1', workCenterId: 'wc-001', status: 'RUNNING', capacityPerHour: 25 },
  { id: 'mc-004', name: 'Packaging Wrapper', workCenterId: 'wc-004', status: 'MAINTENANCE', capacityPerHour: 30 },
];

export const mockWorkOrders: MockWorkOrder[] = [
  {
    id: 'wo-001',
    woNumber: 'WO-2024-001',
    productionOrderId: 'prod-001',
    productionOrderNumber: 'PRD-2024-001',
    stageNumber: 1,
    stageName: 'Material Prep',
    workCenterId: 'wc-002',
    workCenterName: 'Fabrication & Welding',
    machineId: 'mc-001',
    machineName: 'CNC Milling Machine',
    plannedStartDate: '2024-04-15',
    plannedEndDate: '2024-04-18',
    plannedTimeMinutes: 240,
    actualTimeMinutes: 220,
    status: 'COMPLETED',
    completedQty: 5,
    plannedQty: 5,
    operatorId: 'op-001',
    operatorName: 'Ramesh Yadav',
  },
  {
    id: 'wo-002',
    woNumber: 'WO-2024-002',
    productionOrderId: 'prod-001',
    productionOrderNumber: 'PRD-2024-001',
    stageNumber: 2,
    stageName: 'Welding & Assembly',
    workCenterId: 'wc-001',
    workCenterName: 'Assembly Line A',
    machineId: 'mc-003',
    machineName: 'Assembly Robot A1',
    plannedStartDate: '2024-04-19',
    plannedEndDate: '2024-04-22',
    plannedTimeMinutes: 300,
    actualTimeMinutes: 310,
    status: 'IN_PROGRESS',
    completedQty: 2,
    plannedQty: 5,
    operatorId: 'op-002',
    operatorName: 'Suresh Kumar',
  },
  {
    id: 'wo-003',
    woNumber: 'WO-2024-003',
    productionOrderId: 'prod-001',
    productionOrderNumber: 'PRD-2024-001',
    stageNumber: 3,
    stageName: 'Final Inspection',
    workCenterId: 'wc-003',
    workCenterName: 'Quality Inspection',
    machineId: null,
    machineName: null,
    plannedStartDate: '2024-04-23',
    plannedEndDate: '2024-04-25',
    plannedTimeMinutes: 120,
    actualTimeMinutes: 0,
    status: 'PENDING',
    completedQty: 0,
    plannedQty: 5,
    operatorId: null,
    operatorName: null,
  },
];

export const mockOperators = [
  { id: 'op-001', name: 'Ramesh Yadav', skill: 'Welding Expert', shiftId: 'sh-001', wageRatePerHour: 150 },
  { id: 'op-002', name: 'Suresh Kumar', skill: 'Assembly Technician', shiftId: 'sh-001', wageRatePerHour: 120 },
  { id: 'op-003', name: 'Anita Sharma', skill: 'Quality Inspector', shiftId: 'sh-002', wageRatePerHour: 130 },
];

export const mockShifts = [
  { id: 'sh-001', name: 'Morning' },
  { id: 'sh-002', name: 'Evening' },
  { id: 'sh-003', name: 'Night' },
];

export const mockBOMs = [
  { id: 'bom-v001', productId: 'itm-v001', status: 'ACTIVE', version: '1.0' },
  { id: 'bom-v002', productId: 'itm-v002', status: 'ACTIVE', version: '1.0' },
  { id: 'bom-001', productId: 'itm-001', status: 'ACTIVE', version: '1.0' },
  { id: 'bom_pending', productId: 'itm-017', status: 'ACTIVE', version: '0.1' },
  { id: 'bom-hp-500', productId: 'itm-0500', status: 'ACTIVE', version: '1.0' },
  { id: 'bom-gear-box', productId: 'itm-0501', status: 'ACTIVE', version: '1.0' },
  { id: 'bom-motor-200', productId: 'itm-0502', status: 'ACTIVE', version: '1.0' },
  { id: 'bom-0303', productId: 'itm-0303', status: 'ACTIVE', version: '1.0' },
  { id: 'bom-0303-500', productId: 'itm-0303-500', status: 'ACTIVE', version: '1.0' },
];

export const mockBOMItems: MockBOMItem[] = [
  { id: 'bi-001', bomId: 'bom-v001', level: 1, itemId: 'itm-002', itemName: 'Steel Plate 10mm', itemCode: 'RM-STL-01', qtyPerUnit: 2, effectiveQty: 2, unit: 'Pcs', parentId: null, itemType: 'RAW_MATERIAL', standardCost: 150 },
  { id: 'bi-002', bomId: 'bom-v001', level: 1, itemId: 'itm-003', itemName: 'Welding Rods', itemCode: 'RM-WLD-02', qtyPerUnit: 5, effectiveQty: 5, unit: 'Pcs', parentId: null, itemType: 'RAW_MATERIAL', standardCost: 20 },
  { id: 'bi-003', bomId: 'bom-v002', level: 1, itemId: 'itm-004', itemName: 'Copper Wire 2mm', itemCode: 'RM-COP-03', qtyPerUnit: 10, effectiveQty: 10, unit: 'Mtr', parentId: null, itemType: 'RAW_MATERIAL', standardCost: 80 },
];

export const mockDowntimeEntries = [
  {
    id: 'dt-001',
    entryNumber: 'DT-2024-001',
    date: '2024-04-16',
    startTime: '10:00',
    durationMinutes: 45,
    isResolved: true,
    downtimeCodeName: 'Power Failure',
    machineName: 'CNC Milling Machine',
    machineId: 'mc-001',
  },
  {
    id: 'dt-002',
    entryNumber: 'DT-2024-002',
    date: '2024-04-17',
    startTime: '14:30',
    durationMinutes: 120,
    isResolved: false,
    downtimeCodeName: 'Mechanical Breakdown',
    machineName: 'Packaging Wrapper',
    machineId: 'mc-004',
  },
];

export const mockRejectionEntries: any[] = [];

// ─── MRP Mock Data ────────────────────────────────────────────────────────────

export interface MockMRPRun {
  id: string;
  runNumber: string;
  runDate: string;
  runBy: string;
  fromDate: string;
  toDate: string;
  status: 'RUNNING' | 'COMPLETED' | 'FAILED';
  demandOrders: number;
  productionOrders: number;
  itemsAnalyzed: number;
  shortageItems: number;
  purchaseSuggestions: number;
  productionSuggestions: number;
  totalPurchaseValue: number;
  notes: string | null;
  completedAt?: string;
}

export interface MockMRPResult {
  id: string;
  mrpRunId: string;
  itemId: string;
  itemName: string;
  itemCode: string;
  itemType?: string;
  isVariant?: boolean;
  variantName?: string | null;
  unit: string;
  grossRequirement: number;
  currentStock: number;
  reservedStock: number;
  availableStock: number;
  netRequirement: number;
  scheduledReceipts: number;
  finalShortage: number;
  supplierLeadTimeDays: number;
  orderDate: string;
  requiredDate: string;
  status: 'SUFFICIENT' | 'SHORT' | 'CRITICAL';
  suggestedAction: 'NONE' | 'PURCHASE' | 'PRODUCE' | 'EXPEDITE';
  suggestedQty: number;
  estimatedCost: number;
}

export interface MockMRPSuggestion {
  id: string;
  mrpRunId: string;
  type: 'PURCHASE' | 'PRODUCTION';
  itemId: string;
  itemName: string;
  itemCode: string;
  variantName?: string | null;
  suggestedQty: number;
  unit: string;
  requiredDate: string;
  orderByDate: string;
  estimatedCost: number;
  supplierId: string | null;
  supplierName: string | null;
  leadTimeDays: number;
  priority: 'LOW' | 'NORMAL' | 'HIGH' | 'URGENT';
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'CONVERTED';
  convertedDocId?: string | null;
  convertedDocNumber?: string | null;
  notes?: string | null;
  bomVersion?: string;
}

export const mockMRPRuns: MockMRPRun[] = [
  {
    id: 'mrp-001',
    runNumber: 'MRP-2024-001',
    runDate: '2024-04-10',
    runBy: 'Admin User',
    fromDate: '2024-04-10',
    toDate: '2024-05-10',
    status: 'COMPLETED',
    demandOrders: 5,
    productionOrders: 2,
    itemsAnalyzed: 12,
    shortageItems: 3,
    purchaseSuggestions: 2,
    productionSuggestions: 1,
    totalPurchaseValue: 45000,
    notes: 'Initial production plan run',
    completedAt: '2024-04-10T10:05:00Z',
  },
];

export const mockMRPResults: MockMRPResult[] = [
  {
    id: 'mrp-res-001',
    mrpRunId: 'mrp-001',
    itemId: 'itm-001',
    itemName: 'Laptop 15" Core i7',
    itemCode: 'ITM-0001',
    itemType: 'FINISHED_GOOD',
    unit: 'Pcs',
    grossRequirement: 10,
    currentStock: 5,
    reservedStock: 2,
    availableStock: 3,
    netRequirement: 7,
    scheduledReceipts: 0,
    finalShortage: 7,
    supplierLeadTimeDays: 5,
    orderDate: '2024-04-10',
    requiredDate: '2024-05-10',
    status: 'CRITICAL',
    suggestedAction: 'PRODUCE',
    suggestedQty: 7,
    estimatedCost: 504000,
  },
];

export const mockMRPSuggestions: MockMRPSuggestion[] = [
  {
    id: 'sug-001',
    mrpRunId: 'mrp-001',
    type: 'PRODUCTION',
    itemId: 'itm-001',
    itemName: 'Laptop 15" Core i7',
    itemCode: 'ITM-0001',
    suggestedQty: 7,
    unit: 'Pcs',
    requiredDate: '2024-05-10',
    orderByDate: '2024-05-05',
    estimatedCost: 504000,
    supplierId: null,
    supplierName: null,
    leadTimeDays: 5,
    priority: 'URGENT',
    status: 'PENDING',
  },
];

export const mockMaterialReservations: MockMaterialReservation[] = [
  {
    id: 'res-001',
    productionOrderId: 'prod-001',
    itemId: 'bi-001',
    itemName: 'Steel Plate 10mm',
    itemCode: 'RM-STL-01',
    requiredQty: 10,
    reservedQty: 10,
    unit: 'Pcs',
    status: 'RESERVED',
    warehouseId: 'wh-001',
  },
];


